module.exports = __webpack_public_path__ + "static/media/edw-min.f179f2ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/edw-min.svg
// module id = 682
// module chunks = 0